import { FormField } from '@/components/ui/form-field'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {
  COMPANY_SIZE_OPTIONS,
  currentFoundedYearMax,
  FOUNDED_YEAR_MIN,
} from '@/lib/organisation-company-meta'

export type EntityOrganisationCompanyValue = {
  company_size: string
  founded_year: string
}

type EntityOrganisationCompanyFieldsProps = {
  value: EntityOrganisationCompanyValue
  onChange: (patch: Partial<EntityOrganisationCompanyValue>) => void
  idPrefix?: string
  disabled?: boolean
}

const COMPANY_SIZE_NONE = '__none__'

/** Company size select + founded year for organisation identity editors. */
export function EntityOrganisationCompanyFields({
  value,
  onChange,
  idPrefix = 'entity-org-company',
  disabled = false,
}: EntityOrganisationCompanyFieldsProps) {
  const sizeId = `${idPrefix}-company-size`
  const foundedId = `${idPrefix}-founded-year`

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <FormField label="Company size" htmlFor={sizeId}>
        <Select
          value={value.company_size || COMPANY_SIZE_NONE}
          onValueChange={(next) =>
            onChange({ company_size: next === COMPANY_SIZE_NONE ? '' : next })
          }
          disabled={disabled}
        >
          <SelectTrigger id={sizeId} className="w-full">
            <SelectValue placeholder="Select company size" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={COMPANY_SIZE_NONE}>Not set</SelectItem>
            {COMPANY_SIZE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>
      <FormField label="Founded" htmlFor={foundedId}>
        <Input
          id={foundedId}
          type="number"
          inputMode="numeric"
          min={FOUNDED_YEAR_MIN}
          max={currentFoundedYearMax()}
          value={value.founded_year}
          onChange={(event) => onChange({ founded_year: event.target.value })}
          placeholder="e.g. 1985"
          disabled={disabled}
        />
      </FormField>
    </div>
  )
}
